import type { KeyedImage } from '.';
import useImageAsDataUrl from '@/lib/utils/useImageAsDataUrl';
import { useState } from 'react';
import ClickableImageFilename from '@/components/FileAttachments/UploadedImage/ImagePreview/ClickableImageFilename';
import ImagePreviewLoadingState from '@/components/FileAttachments/UploadedImage/ImagePreviewLoadingState';
import PreviewDialog from '@/components/FileAttachments/UploadedImage/ImagePreview/ImagePreviewDialog/StyledDialog';
import Dialog from '@/components/Dialog';
import { IconButton } from '@mui/material';
import Space from '@/components/Space';
import { Close as CloseIcon } from '@mui/icons-material';
import StyledImagePreviewThumbnail from '@/components/FileAttachments/UploadedImage/ImagePreview/ImagePreviewThumbnail/StyledImagePreviewThumbnail';
import { useIntl } from 'react-intl';

type NewLogEntryImagePreviewProps = {
  image: KeyedImage;
};

const NewLogEntryImagePreview = ({ image }: NewLogEntryImagePreviewProps) => {
  const intl = useIntl();

  const imageAsDataUrl = useImageAsDataUrl(image.key, image.imageFile);
  const [previewDialogOpen, setPreviewDialogOpen] = useState(false);

  if (imageAsDataUrl === null) {
    return <ImagePreviewLoadingState imageFilename={image.imageFile.name} />;
  }

  return (
    <>
      <StyledImagePreviewThumbnail
        src={imageAsDataUrl}
        onClick={() => setPreviewDialogOpen(true)}
      />
      <ClickableImageFilename onClick={() => setPreviewDialogOpen(true)}>
        {image.imageFile.name}
      </ClickableImageFilename>
      <PreviewDialog
        open={previewDialogOpen}
        onClose={() => setPreviewDialogOpen(false)}
      >
        <Dialog.Title>
          {image.imageFile.name}
          <Space width="auto" />
          <IconButton onClick={() => setPreviewDialogOpen(false)}>
            <CloseIcon />
          </IconButton>
        </Dialog.Title>
        <Dialog.Content>
          <img
            src={imageAsDataUrl}
            alt={intl.formatMessage(
              {
                id: 'portfolio.challenge.files.uploaded_image.preview_dialog.preview_image_alt',
              },
              {
                imageFilename: image.imageFile.name,
              },
            )}
          />
        </Dialog.Content>
      </PreviewDialog>
    </>
  );
};

export default NewLogEntryImagePreview;
